<template lang="pug">
  .b2b-page-estadisticas-topseller
    ods-module
      div(slot='header')
        ods-row.info(type='flex', align='middle')
          ods-col(:span='8')
            div {{ $t('statistic.topseller_title') }}
      ods-form(
        ref='statisticForm',
        :rules='rulesStatisticForm',
        :model='statisticForm',
        label-width='14rem',
        label-position='top',
        size='mini')
        ods-row(type='flex')
          ods-col(:span='4')
            ods-form-item(
              :label='$t("chart_type.title")',
              prop='chartTypeCode')
              ods-select(
                v-model='statisticForm.chartTypeCode',
                filterable,
                @change='changeOption',
                :placeholder='$t("chart_type.title")')
                ods-option(
                  v-for='option in optionsTypeResult',
                  :key='option.value',
                  :label='option.label',
                  :value='option.value')
          ods-col(v-if='activeUser.data.isSuperAdmin || !activeUser.data.projects || (activeUser.data.projects && activeUser.data.projects.length > 1)', :span='1')
          ods-col(v-if='activeUser.data.isSuperAdmin || !activeUser.data.projects || (activeUser.data.projects && activeUser.data.projects.length > 1)', :span='4')
            ods-form-item(
              v-if='activeUser.data.isSuperAdmin || !activeUser.data.projects || (activeUser.data.projects && activeUser.data.projects.length > 1)',
              :label='$t("new_invoice.new_invoice_form.service")',
              prop='idProject')
              ods-select(
                v-model='statisticForm.idProject',
                @change='changeOption',
                filterable)
                ods-option(
                  v-for='project in optionsService',
                  :key='project.id',
                  :label='project.name',
                  :value='project.id')
          ods-col(:span='1')
          ods-col(:span='4')
            ods-form-item(
              :label='$t("invoice_detail.invoice_detail_edit_form.communication_reception_method")',
              prop='receptionCode')
              ods-select(
                v-model='statisticForm.receptionCode',
                @change='changeOption',
                filterable)
                ods-option(
                  v-for='option in optionsReception',
                  :key='option.value',
                  :label='option.label',
                  :value='option.value')
          ods-col(:span='1')
          ods-col(:span='6')
            ods-form-item(
              :label='$t("msg_generics.date_filter")',
              prop='filterDateFrom')
              ods-date-picker(
                v-model='statisticForm.filterDateFrom',
                @change='changeOption',
                type='month',
                :format='$t("date_format_month")',
                prefix-icon='prefix-icon-date-time-picker',
                :placeholder='$t("msg_generics.datepicker.start_placeholder")')
              ods-date-picker(
                v-model='statisticForm.filterDateTo',
                @change='changeOption',
                type='month',
                :format='$t("date_format_month")',
                prefix-icon='prefix-icon-date-time-picker',
                :placeholder='$t("msg_generics.datepicker.end_placeholder")')
          ods-col(:span='1')
          ods-col(:span='2'
            style='padding-top: 20px;')
            ods-tooltip(:content='$t("buttons.btnShow_tooltip")', placement='bottom')
              ods-button(
                type='primary',
                size='medium',
                @click='saveInfoInvoice("statisticForm")')
                | {{ $t('buttons.btnShow') }}
        //- Tabla metodos de entrega de una empresa
        ods-table(
          v-if='results.length > 0 ',
          :data='results',
          style='width: 100%',
          highlight-current-row,
          size='mini',
          fit)
          ods-table-column(
            width='650',
            prop='nameSeller',
            :label='$t("parties.entity_table.name")',
            :show-overflow-tooltip='true',
            sortable='')
          ods-table-column(
            width='80',
            prop='countrySeller',
            :label='$t("parties.entity_table.country")',
            :show-overflow-tooltip='true',
            sortable='')
          ods-table-column(
            width='200',
            prop='nifSeller',
            :label='$t("profile.parties.entity_table.tax_identification_number")',
            :show-overflow-tooltip='true',
            sortable='')
          ods-table-column(
            v-if='this.statisticForm.chartTypeCode=="E"',
            prop='totalAmount',
            :label='$t("invoices.invoices_entity_table.amount")',
            align='right',
            :show-overflow-tooltip='true',
            :formatter='formatterDecimal'
            sortable='')
          ods-table-column(
            v-if='this.statisticForm.chartTypeCode=="F"',
            prop='totalInvoices',
            :label='$t("chart_type.invoice")',
            align='right',
            :show-overflow-tooltip='true',
            sortable='')
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import Utils from '@/components/shared/Utils'

export default {
  name: 'b2b-page-estadisticas-topseller',
  mixins: [Utils],

  data () {
    return {
      // DatePicker
      statisticForm: {
        filterDateFrom: null,
        filterDateTo: null,
        idProject: null,
        chartTypeCode: null,
        receptionCode: null
      },
      optionsService: [],
      results: {},
      optionsReception: [
        {
          value: null,
          label: null
        },
        {
          value: 'EMAIL',
          label: this.$t('communication_method.EMAIL')
        },
        {
          value: 'PAPER',
          label: this.$t('communication_method.PAPER')
        }
      ],
      // Combo tipo grafica
      optionsTypeResult: [
        {
          value: 'E',
          label: this.$t('chart_type.economic')
        },
        {
          value: 'F',
          label: this.$t('chart_type.invoice')
        }
      ]
    }
  },

  computed: {
    ...mapGetters([
      'optionsServicesEnabled',
      'activeUser',
      'urlIn'
    ]),

    rulesStatisticForm () {
      const checkDateTo = (rule, value, callback) => {
        if (this.statisticForm.filterDateTo == null || this.statisticForm.filterDateTo === '') {
          callback(new Error(this.$t('msg_generics.date_range_required')))
        } else {
          callback()
        }
      }
      const checkRangeDate = (rule, value, callback) => {
        if (this.statisticForm.filterDateFrom >= this.statisticForm.filterDateTo) {
          callback(new Error(this.$t('profile.error.parties.validation.date')))
        }
        callback()
      }
      return {
        chartTypeCode: [
          { required: true, message: this.$t('msg_generics.element_selected'), trigger: 'change' }
        ],
        idProject: [
          { required: true, message: this.$t('msg_generics.element_selected'), trigger: 'change' }
        ],
        filterDateFrom: [
          { required: true, message: this.$t('msg_generics.date_range_required'), trigger: 'change' },
          { validator: checkDateTo, trigger: 'blur, change' },
          { validator: checkRangeDate, trigger: 'blur, change' }
        ],
        filterDateTo: [
          { required: true, message: this.$t('msg_generics.date_range_required'), trigger: 'change' },
          { validator: checkDateTo, trigger: 'blur, change' },
          { validator: checkRangeDate, trigger: 'blur, change' }
        ]
      }
    }
  },

  methods: {
    ...mapActions([
      'getOptionsService',
      'getDataInvoiceSellerAmount',
      'optionsServicesEnabledState'

    ]),
    changeOption (data) {
      this.results = {}
    },
    async saveInfoInvoice (formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          const load = this.$loading({
            lock: true,
            text: this.$t('new_invoice.new_invoice_form.load.text_load_data')
          })
          this.results = {}
          try {
            const dataQuery = {
              idProject: this.statisticForm.idProject,
              filterDateFrom: this.statisticForm.filterDateFrom,
              filterDateTo: this.statisticForm.filterDateTo,
              emitted: false,
              typeTable: this.statisticForm.chartTypeCode,
              receptionMethod: this.statisticForm.receptionCode
            }
            const response = await this.getDataInvoiceSellerAmount(dataQuery)
            this.results = response.data
            console.log('results: ', this.results)
          } catch (error) {
            this.getNotificationErrorMessage(error)
          } finally {
            load.close()
          }
        } else {
          return false
        }
      })
    },
    formatterDecimal (row, column) {
      if (row[column.property] == null) {
        return this.$t('msg_generics.no_price')
      } else if (row[column.property] || row[column.property] === 0) {
        let amount = this.$n(row[column.property], 'table')
        if (amount.toString().length === 7) {
          const part1 = amount.substring(0, 1)
          const part2 = amount.substring(1, 7)
          amount = part1 + '.' + part2
        }
        return amount
      } else {
        return ''
      }
    },
    async getNotificationErrorMessage (error) {
      const statusCode = error.status
      let errorSmsList = []
      let errorSms = ''
      let errorArgList = []

      errorArgList = error.data.errorArgList
      errorSmsList = error.data.messageList

      switch (statusCode) {
        case 400:

          if (error.data.message !== null && errorArgList === null && typeof errorSmsList === 'undefined') {
            errorSms = error.data.message
            break
          } else if (errorArgList === null && typeof errorSmsList === 'undefined') {
            errorSms = 'error.e400_create_invoice'
            break
          } else {
            break
          }

        case 401:
          errorSms = 'error.e401'
          break
        case 403:
          errorSms = 'error.e403'
          break
        case 409:
          errorSms = 'error.e409_create_invoice'
          break
        case 500:
          errorSms = 'error.e500'
          break
        default:
          errorSms = 'error.default'
          break
      }
      error.data.message = errorSms
      this.showNotificationError(error)
    }
  },

  async created () {
    const load = this.$loading({
      lock: true,
      text: this.$t('new_invoice.new_invoice_form.load.text_load_init_data')
    })

    try {
      // Si tiene 1 solo proyecto seteamos el proyecto
      if (this.activeUser.data.projects && this.activeUser.data.projects.length === 1) {
        this.statisticForm.idProject = this.activeUser.data.projects[0].id
      }

      // Nueva factura desde borradores empieza de  nuevas
      const dataQuery = { page: 0, size: 1000, sort: 'name,ASC', isReceiver: true, urlName: (this.urlIn && this.urlIn !== 'b2b' ? this.urlIn : null) }
      const resultServ = await this.getOptionsService(dataQuery)

      const allProject = {
        code: '',
        id: -1,
        isReceiver: null,
        isSender: null,
        name: this.$t('user_detail.dialog_add_user_entity.option_all_project')
      }

      this.optionsService.push(allProject)
      this.optionsService.push.apply(this.optionsService, resultServ)

      // this.optionsService.push(allProject)
      await this.optionsServicesEnabledState(this.optionsService)

      // Rango por defecto: 12 meses
      const start = new Date()
      const end = new Date()
      start.setMonth(start.getMonth() - 12)

      this.statisticForm.filterDateFrom = start
      this.statisticForm.filterDateTo = end
    } catch (error) {
      this.getNotificationErrorMessage(error)
    } finally {
      load.close()
    }
  }
}
</script>

<style lang="scss" scoped>
.ods-form-item.divVacio.ods-form-item--mini {
      margin-bottom: 86px;
    }
.b2b-page-estadisticas-topseller {
  padding: 40px 40px 40px 40px;

  ::v-deep .ods-module{
    &__header{
      background-color: var(--color-bg-hover-2);
      padding: 0px;
      .info{
        margin-left: 40px;
        margin-right: 40px;
        height: 72px;
        color: var(--color-bg-interactive);
        size: 16px;
        line-height: 24px;
      }
    }

    &__body{
      padding: 32px;
      .info{
        padding-bottom: 32px;
      }

      .subtitle{
        margin-top: 40px;
        font-size: 14px;
        font-weight: 500;
        text-transform: uppercase;
      }

      ::v-deep .ods-table{
        margin-bottom: rem(18);
        margin-top: 40px;
        th {
          padding: rem(0);
          padding-top: rem(4);

          .cell {
            font-weight: 500;
          }
        }
        &__row{
          .ods-button {
            padding: 0px;
            margin-left: 0px;
            margin-right: 0px;
            i {
              margin-left: 0px;
            }
          }
          .first-button {
            padding: 0px;
            margin-left: 0px;
            margin-right: rem(12);
            i {
              margin-left: 0px;
            }
          }
        }
      }
    }
  }
  .form-actions{
    padding-top: 40px;
    padding-bottom: 40px;
    .ods-button{
      float: right;
    }
  }
 ::v-deep .ods-date-editor.ods-input {
   width: 109px;
   margin-right: 24px;
 }
  ::v-deep .ods-input--prefix .ods-input__inner{
    padding-left: 10px;
  }
  .ods-button--small.is-round {
    margin-top: 40px;
  }

}
</style>
